module.exports = __webpack_public_path__ + "static/media/check-circle.32cd4a7f.svg";